import type { FaireProductEntity } from "../../entity_types/product";

export const p_e9v9pnsmtf: FaireProductEntity = {
  token: "p_e9v9pnsmtf",
  type: "product",
  name: "Wide Base Mug with Pine Trees",
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/38f327560758114068b854493116c5c3eff8708fdbe676b49a51eccd3345ce8c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c57882929d00dc56e446a82056dc3d668e3f081cdbffd1129d59b4122d994980.jpeg",
    "https://cdn.faire.com/fastly/a3e8f9e07502f53462b25715b078a11c666d205f2ededa6d6a0a72889c87e10e.jpeg",
    "https://cdn.faire.com/fastly/4adc7218e660a02d2ea4ebd412251d09d5eb5ed50ef0a068783de0ce6c7874c5.jpeg",
  ],
  priceDollars: 6,
  description:
    "Elevate your winter mornings with our wide base pine trees mug. This charming stoneware piece features a design of multiple trees, capturing a frosty forest aesthetic. Perfect for sipping your favourite hot beverages while surrounded by images of nature.",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:17.103Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
